/* import __COLOCATED_TEMPLATE__ from './tab-area.hbs'; */
﻿import Component from '@ember/component';

/////////////////////////////////////////////////////////////////////////////////////
// tab-area - Component for holding the contents of the outputs of the application //
// (diamond graph, internal circuit, table of recommended parts)                   //
/////////////////////////////////////////////////////////////////////////////////////

export default class TabArea extends Component {
  tagName = '';
}
